export const CONTACT = {
  email: "department@liinexinfo.org",
  phones: ["+91 79828 10821", "+91 98973 88350"],
  phonesRaw: ["+917982810821", "+919897388350"],
  address: "36, Signature Street Road, Govind Vihar, Ghaziabad, Uttar Pradesh, India 201013",
  addressLines: [
    "36, Signature Street Road",
    "Govind Vihar, Ghaziabad",
    "Uttar Pradesh, India 201013",
  ],
};

export const LOGO_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_liinex-solutions/artifacts/4tm0n5i6_lis%20logo%20png.png";

export const LOGO_MARK = "/lis-mark.png";

export const NAV = [
  { label: "Work", to: "/#services" },
  { label: "Studio", to: "/#studio" },
  { label: "Journal", to: "/blog" },
  { label: "Careers", to: "/careers" },
];

export const SERVICE_OPTIONS = [
  "Website Development",
  "Software Development",
  "Gen AI Trainings",
  "Digital Marketing",
  "Something else",
];
